import { gql } from '@apollo/client';

export const GET_ALL_PARTICIPANTS_QUERY = gql`
  query participants {
    get(binderId: $binderId)
      @rest(
        type: "participants"
        path: "/{args.binderId}/participants/support"
        endpoint: "binder"
      ) {
      binderId
      id
      user
      level
      description
      deleted
      createdDate
      roles
      user
    }
  }
`;
